import { max as maxFns } from 'date-fns';

export default function max(dates: Date[]): Date {
  return maxFns(dates);
}
